<template>
  <v-dialog v-model="showDialog" max-width="500">
    <v-alert class="mb-0" v-if="fileAlertType" :type="fileAlertType">{{ fileAlertText }}</v-alert>
    <template v-if="!noButton" v-slot:activator="{on}">
      <v-btn
          outlined
          color="primary"
          v-on="on"
      >
        <v-icon left>file_upload</v-icon>
        <span v-if="!imagePath">
          {{ $t('buttons:upload-specific', { specific: $t('common:image_plural')}) }}
        </span>
        <span v-else>
          {{ $t('buttons:edit') }}
        </span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h4 class="primary--text font-weight-medium">{{ $t('components:image-upload-form.title') }}</h4>
      </v-card-title>
      <v-card-text>
        <v-row justify="space-around">
          <v-col cols="10" sm="4">
            <h6 class="greyTint--text font-weight-medium mb-0">{{ $t('components:image-upload-form.preview') }}</h6>
            <v-img
                v-if="filePath || imagePath"
                :src="filePath ? filePath : imagePath"
                aspect-ratio="1"
                contain
            />
            <v-img v-else src="@/assets/image_preview.png" aspect-ratio="1" contain/>
          </v-col>
          <v-col cols="12" sm="6" align-self="center">
            <v-form ref="fileForm">
              <v-file-input
                  accept="image/*"
                  :label="$t('components:common.filename')"
                  show-size
                  :rules="[
                    ruleRequired($t('utils:rules.requiredFile')),
                    ruleMaxFileSize(fileSizeLimit,$t('utils:rules.filesize', {size : '2 MB'}))
                    ]"
                  v-model="computedFile"
                  @change="showPreviewImage"
              />
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            :disabled="!file"
            @click="uploadImage"
            color="primary"
        >
          {{ $t('buttons:upload') }}
        </v-btn>
        <v-btn
            :disabled="!imagePath"
            @click="$emit('deleteImage');"
            color="error"
        >
          {{ $t('buttons:delete') }}
        </v-btn>
        <v-btn
            @click="showDialog = false;"
            color="grey"
        >
          {{ $t('buttons:close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {ruleRequired, ruleMaxFileSize} from "../services/rules";

export default {
  name: "ImageUploadForm",
  props: {
    imagePath: String,
    noButton: Boolean
  },
  data() {
    return {
      file: null,
      filePath: null,
      fileAlertType: "",
      fileAlertText: "",
      showDialog: false,
    }
  },
  methods: {
    uploadImage() {
      this.$emit('uploadImage', this.$refs.fileForm);
    },
    /**
     * Triggered on file update, shows newly uploaded file to the user.
     *
     * @param file uploaded by user
     */
    showPreviewImage(file) {
      if (file) {
        this.filePath = URL.createObjectURL(file);
      } else if (this.imagePath) {
        this.filePath = this.imagePath;
      } else {
        this.filePath = null;
      }
      this.$emit('updatedFilePath', this.filePath);
    },

    setAlertSettings(fileAlertType, fileAlertText) {
      this.fileAlertType = fileAlertType;
      this.fileAlertText = fileAlertText;
    },

    ruleMaxFileSize,
    ruleRequired
  },
  computed: {
    computedFile: {
      get() {
        if(this.file) {
          return this.file;
        }
        return null;
      },
      set(val) {
        if(val) {
          this.file = val;
        }
        this.$emit('update', val);
      }
    },
    fileSizeLimit() {
      return process.env.VUE_APP_UPLOAD_SIZE_IMAGE;
    }
  }
}
</script>
